import React, { useEffect, useRef, useState } from "react";
import "./AboutPage.css";
import headerImg from "../images/AboutPage_header.png";
import founderDeco from "../images/AboutPage_founderDeco.png";
import founderImage from "../images/AboutPage_founderImage.png";
import chefHat from "../images/AboutPage_chefHatYellow.png";
import chefHatPink from "../images/AboutPage_chefHatPink.png";
import photoBackdrop from "../images/AboutPage_photoBackdrop.png";
import miaImg from "../images/directors/mia.png";
import alexImg from "../images/directors/AlexandraHeadshot.jpg";
import sofiaImg from "../images/directors/Sofia.jpg";
import aliceImg from "../images/directors/Alice_Headshot.jpg";
import mylienImg from "../images/directors/MylienHeadshot.jpg";
import tylerImg from "../images/directors/TylerHeadshot.png";
import tiffanyImg from "../images/directors/TiffanyHeadshot.jpeg";
import tisheikaImg from "../images/directors/TisheikaHeadshot.png";
import jennaImg from "../images/directors/JennaHeadshot.png";
import ArrowLeft from "../images/ArrowLeft.png";
import ArrowRight from "../images/ArrowRight.png";
import starsBg from "../images/AboutPage_stars.png";
import burgerImg from "../images/Burger.png";
import wrapImg from "../images/Wrap.png";
import dumplingImg from "../images/Dumpling.png";

function AboutPage() {
    return (
        <div className="about-page">
            <header className="about-header">
                <img
                    src={headerImg}
                    alt="About header"
                    className="header-image-about"
                />
                <div className="header-overlay" />
                <div className="header-text-about">
                    <div className="intro-subtitle">INTRODUCING THE TEAM</div>
                    <h1 className="about-title">A Dash Of Us</h1>
                    <p className="about-body">
                        Cultured Kids Cuisine aims to empower the{" "}
                        <span className="about-highlight">next generation</span>{" "}
                        of youthful and culturally aware critical thinkers. Our
                        motive is to provide free access to{" "}
                        <span className="about-highlight">
                            cultural education
                        </span>{" "}
                        in order to foster a welcoming environment filled with
                        individuals from diverse socioeconomic and cultural
                        backgrounds. By fostering love and peace, we hope to
                        mitigate the chaos sprouting from social media and the
                        virtual world and instead promote lively human
                        interaction through our{" "}
                        <span className="about-highlight">
                            cooking services
                        </span>
                        ; ultimately, bringing families together around the joy
                        of exploring international flavors.
                    </p>
                </div>
            </header>

            <main className="about-content">
                <section className="founder-section">
                    <img
                        src={founderDeco}
                        alt="decorative"
                        className="founder-deco"
                        aria-hidden="true"
                    />
                    <h2 className="founder-heading">A Word From Our Founder</h2>
                    <div className="founder-container">
                        <div className="founder-media">
                            <div className="founder-image-wrapper">
                                <img
                                    src={chefHat}
                                    alt="chef hat"
                                    className="chef-hat"
                                    aria-hidden="true"
                                />
                                <img
                                    src={founderImage}
                                    alt="Mia Kotikovski"
                                    className="founder-photo"
                                />
                            </div>
                        </div>

                        <div className="founder-copy">
                            <div className="founder-name">MIA KOTIKOVSKI</div>
                            <div className="founder-title">Founder and CEO</div>
                            <p className="founder-text">
                                My Russian immigrant mother, who was passionate
                                about Bhangra and Asian curry, instilled an
                                appreciation for cultures in me. Growing older,
                                I was disturbed by racial prejudice in society,
                                including cafeteria bullying and media
                                discrimination. To combat hate and promote love
                                and tolerance, I founded “Cultured Kids
                                Cuisine," an educational initiative using food
                                to connect people and foster understanding.
                                Future leaders run the program with the goal of
                                uniting everyone through the power of food.
                            </p>
                        </div>
                    </div>
                </section>
                <section className="directors-section">
                    <h2 className="directors-heading">Meet The Directors</h2>
                    <DirectorsSlider />
                </section>
                <section
                    className="interns-section"
                    aria-labelledby="interns-heading"
                >
                    <div
                        className="interns-shell"
                        style={{ "--interns-stars": `url(${starsBg})` }}
                    >
                        <h2 id="interns-heading" className="interns-heading">
                            Intern Insights
                        </h2>
                        <InternsSlider />
                    </div>
                </section>
            </main>
        </div>
    );
}

export default AboutPage;

function DirectorsSlider() {
    const directors = [
        {
            id: 1,
            image: miaImg,
            quote: "I am a medical student at the Renaissance School of Medicine at Stony Brook University with aspirations in pediatric surgery, driven by a commitment to improving children's lives both inside and outside the clinical setting. I connect deeply with CKC's mission because I believe food is a powerful bridge between cultures, and sharing global cuisines enables children to embrace diversity, celebrate their heritage, and foster understanding in an accessible way.",
            author: "MIA KOTIKOVSKI",
            role: "President & CEO",
        },
        {
            id: 2,
            image: alexImg,
            quote: "I am a graduate of Stony Brook University with a B.S. in Health Science in pursuit of a career in medicine. I love working with my peers at Cultured Kids Cuisine to teach children about the world around them in a fun and hands-on way that grants cultural awareness through the passion of cooking!",
            author: "ALEX PORTSCHELLER",
            role: "Director of Marketing",
        },
        {
            id: 3,
            image: sofiaImg,
            quote: "Sofia graduated from Northeastern University in May 2025 and is now a Marketing Coordinator at a consulting firm in Boston. She loves being part of the CKC team, where she's built strong bonds and found inspiration in the collaboration, creativity, and camaraderie among teammates.",
            author: "SOFIA LONG",
            role: "Director of Creative Design",
        },
        {
            id: 4,
            image: aliceImg,
            quote: "I recently graduated with a degree in Business Administration. While I work in the world of business during the day, I am grateful to be a part of CKC, where I get to connect with people from many different backgrounds. I also get to work with educating the new generation about cultures around the world through food!",
            author: "ALICE LIAN",
            role: "Culinary Director",
        },
        {
            id: 5,
            image: mylienImg,
            quote: "I am a biochemistry major at SUNY University at Buffalo, and the senior news editor of its student newspaper. I joined CKC because I love creating things - whether it's in a research lab, the newsroom or at home with a cup of coffee over our collection of recipes. And I find a home here at CKC with my dynamic interests - everyone is doing something unique but we're all linked by how passionate we are to bring cultural dishes to the forefront.",
            author: "MYLIEN LAI",
            role: "Director of Content Creation",
        },
        {
            id: 6,
            image: tylerImg,
            quote: "My name is Tyler and I'm an English Teacher from Rockland County, NY. I love being involved in community and exploring different cultures; since joining CKC I've had the privilege of experiencing and sharing new cultures through writing about one of the most important things: food!",
            author: "TYLER RIVERS",
            role: "Editor-in-Chief",
        },
        {
            id: 7,
            image: tiffanyImg,
            quote: "I'm currently attending Stony Brook University, majoring in Health Science with aspirations to become a pediatrician. I connect the most with CKC's mission of spreading, connecting, and listening to stories of children and families around the globe over food!",
            author: "TIFFANY LIN",
            role: "Director of Fundraising & Sponsorships",
        },
        {
            id: 8,
            image: tisheikaImg,
            quote: "I'm Tisheika and I'm a 2024 graduate of Stony Brook University. I studied psychology and earned a baccalaureate during my time. Now, I'm an aspiring nursing student while I work in a physical therapy clinic. I adore the mission of CKC and the opportunity to collaborate with other passionate and driven youths.",
            author: "TISHEIKA RICHARDS",
            role: "Director of Fundraising & Sponsorships",
        },
        {
            id: 9,
            image: jennaImg,
            quote: "I'm a first-year graduate student at UC Berkeley studying Information, with a focus on UX Design and Product Management. I'm drawn to CKC because I believe food has a unique ability to bring people together across cultures. As someone who's moved often for school, sharing and discovering food has been one of the most meaningful ways I build community wherever I go.",
            author: "JENNA LI",
            role: "Director of Website Design",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    const [direction, setDirection] = useState("next");
    const director = directors[activeIndex];

    const showDirector = (nextIndex) => {
        const normalizedIndex = (nextIndex + directors.length) % directors.length;
        if (normalizedIndex === activeIndex) return;
        setDirection(nextIndex > activeIndex ? "next" : "previous");
        setActiveIndex(normalizedIndex);
    };

    const previous = () => showDirector(activeIndex - 1);
    const next = () => showDirector(activeIndex + 1);

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setDirection("next");
            setActiveIndex((currentIndex) =>
                (currentIndex + 1) % directors.length
            );
        }, 10000);

        return () => window.clearInterval(intervalId);
    }, [directors.length]);

    return (
        <div className="directors-carousel" aria-roledescription="carousel">
            <button
                type="button"
                className="directors-carousel-arrow directors-carousel-arrow-previous"
                onClick={previous}
                aria-label="Show previous director"
            >
                <img src={ArrowLeft} alt="" aria-hidden="true" />
            </button>

            <article
                key={director.id}
                className={`directors-carousel-card directors-carousel-card--${direction}`}
                aria-label={`${director.author}, ${director.role}`}
            >
                <header className="directors-carousel-header">
                    <h3>{director.author}</h3>
                    <p>{director.role}</p>
                </header>

                <div className="directors-carousel-portrait" aria-hidden="true">
                    <img
                        className="directors-carousel-portrait-decoration"
                        src={photoBackdrop}
                        alt=""
                    />
                    <img
                        className="directors-carousel-portrait-image"
                        src={director.image}
                        alt={`Portrait of ${director.author}`}
                    />
                    <img
                        className="directors-carousel-hat"
                        src={chefHatPink}
                        alt=""
                        aria-hidden="true"
                    />
                </div>

                <blockquote className="directors-carousel-quote">
                    {director.quote}
                </blockquote>
            </article>

            <button
                type="button"
                className="directors-carousel-arrow directors-carousel-arrow-next"
                onClick={next}
                aria-label="Show next director"
            >
                <img src={ArrowRight} alt="" aria-hidden="true" />
            </button>

            <div className="directors-carousel-dots" role="tablist" aria-label="Directors">
                {directors.map((item, index) => (
                    <button
                        key={item.id}
                        type="button"
                        className={index === activeIndex ? "is-active" : ""}
                        onClick={() => showDirector(index)}
                        role="tab"
                        aria-selected={index === activeIndex}
                        aria-label={`Show ${item.author}`}
                    />
                ))}
            </div>
        </div>
    );
}

function InternsSlider() {
    const interns = [
        {
            id: 1,
            image: burgerImg,
            quote: "Being with CKC for almost a year now, I learned a lot about responsibility and how to engage with others. Most importantly, I had the opportunity to work with other incredible women and to share my love for food and culture with my community.",
            author: "Renee M.",
            role: "Culinary Manager",
        },
        {
            id: 2,
            image: wrapImg,
            quote: "When I first joined CKC, I had no idea that it would have the amazing impact that it did. I've developed amazing leadership and social skills, all of which have helped me land internships and jobs.",
            author: "Taylor L.",
            role: "Digital Marketing & Engagement Manager",
        },
        {
            id: 3,
            image: dumplingImg,
            quote: "CKC gave me the chance to learn and grow so much over the course of this semester. I was able to reach out and connect with so many driven and independent women who inspire me to work for and reach my entrepreneurial goals.",
            author: "Michelle H.",
            role: "Fundraising & Sponsorship Intern",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const touchStartX = useRef(null);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 900px)");

        const updateLayout = () => {
            setIsMobile(mediaQuery.matches);
        };

        updateLayout();

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener("change", updateLayout);
        } else {
            mediaQuery.addListener(updateLayout);
        }

        return () => {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener("change", updateLayout);
            } else {
                mediaQuery.removeListener(updateLayout);
            }
        };
    }, []);

    useEffect(() => {
        setActiveIndex(0);
    }, [isMobile]);

    useEffect(() => {
        if (!isMobile) return;

        const intervalId = window.setInterval(() => {
            setActiveIndex((currentIndex) => (currentIndex + 1) % interns.length);
        }, 15000);

        return () => window.clearInterval(intervalId);
    }, [isMobile, interns.length]);

    const showSlide = (nextIndex) => {
        setActiveIndex((nextIndex + interns.length) % interns.length);
    };

    const handleTouchStart = (event) => {
        touchStartX.current = event.touches[0].clientX;
    };

    const handleTouchEnd = (event) => {
        if (touchStartX.current === null) return;

        const endX = event.changedTouches[0].clientX;
        const swipeDistance = touchStartX.current - endX;

        if (swipeDistance > 40) {
            showSlide(activeIndex + 1);
        } else if (swipeDistance < -40) {
            showSlide(activeIndex - 1);
        }

        touchStartX.current = null;
    };

    const renderInternCard = (intern, index, className = "") => (
        <article
            key={intern.id}
            className={`intern-card ${!isMobile && index % 2 === 1 ? "intern-card-odd" : ""} ${className}`.trim()}
        >
            <img
                src={intern.image}
                alt={`${intern.author} illustration`}
                className="intern-card-image"
            />
            <div className="intern-card-copy">
                <p className="intern-quote">{intern.quote}</p>
                <div className="intern-author">{intern.author}</div>
                <div className="intern-role">{intern.role}</div>
            </div>
        </article>
    );

    const renderInternCardMobile = (intern, className = "") => (
        <article
            key={intern.id}
            className={`intern-card-mobile ${className}`.trim()}
        >
            <div className="intern-card-copy">
                <div className="intern-author">{intern.author}</div>
                <div className="intern-role">{intern.role}</div>
                <img
                src={intern.image}
                alt={`${intern.author} illustration`}
                className="intern-card-image" />
                <p className="intern-quote">{intern.quote}</p>
            </div>
        </article>
    );

    if (!isMobile) {
        return (
            <div className="interns-carousel interns-carousel-desktop">
                <div className="interns-desktop-grid">
                    {interns.map((intern, index) => renderInternCard(intern, index))}
                </div>
            </div>
        );
    }

    return (
        <div className="interns-carousel interns-carousel-mobile">
            <div
                className="interns-mobile-viewport"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >
                <div
                    className="interns-mobile-track"
                    style={{ transform: `translateX(-${activeIndex * 100}%)` }}
                >
                    {interns.map((intern, index) =>
                        renderInternCardMobile(intern, "intern-card-mobile"),
                    )}
                </div>
            </div>

            <div className="interns-dots" role="tablist" aria-label="Intern insights slides">
                {interns.map((intern, index) => (
                    <button
                        key={intern.id}
                        className={`interns-dot ${index === activeIndex ? "active" : ""}`}
                        onClick={() => showSlide(index)}
                        aria-label={`Show intern insight ${index + 1}`}
                        aria-pressed={index === activeIndex}
                    />
                ))}
            </div>
        </div>
    );
}
